import * as React from 'react';
// import * as ReactDOM from 'react-dom';

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";





/**
 * 
 * Lightning Container
 * 
 * https://developer.salesforce.com/docs/atlas.en-us.lightning.meta/lightning/container_overview.htm
 * 
 * https://github.com/ccoenraets/lightning-container-component-samples/blob/master/force-app/main/default/staticresources/lcc_sample_es5/lcc.js
 * 
 * 
 * Using lightning container
 * 
 * https://developer.salesforce.com/docs/atlas.en-us.lightning.meta/lightning/container_js.htm
 * 
 */
import { usePromise } from '@infonova/framework/lib/react/hooks/usePromise';
import { useService } from '@infonova/framework/lib/react/hooks/useService';
import { ExternalServiceConfiguration } from "./app/configuration/ExternalServiceConfiguration";


import './sass/style.scss';

// import * as infonova from './infonova';

import { HelloComponent } from './app/hello';

ExternalServiceConfiguration.configure();

// ReactDOM.render(
//     <HelloComponent/>,
//     document.getElementById('root')
// );


const root = createRoot(document.getElementById("root"));
root.render(
    <HelloComponent/>
);